const calcProbRainfall = (amount, a, b) => {
  // console.log('power = (amount-b)/a where b and a are the regression parameters for the given location, scenario, and duration')  
  let power = (amount-b)/a
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/exp
    // console.log('probability = 1/Math.exp(power).toFixed(2)*100')
    return (1/Math.exp(power))*100
    
  }

  export default calcProbRainfall